<template lang="pug">
.footer_outline
	.particle_wrapper.footer
	#footer
		//- #particle_footer
		.container-fluid
			.row
				.col-sm-7
					img.logo(src='@/assets/images/logo_blue.png')
					p {{ $t('footer_title') }}
					.desc
						| {{ $t('footer_tel') }}：02-2633-2000 #8013
						br
						| {{ $t('footer_address_title') }}：{{ $t('footer_address') }}
						br
						| Public Television Service Foundation. All Rights Reserved.
				.col-sm-5
					.sponsor: .d-flex.align-items-center.flex-wrap.w-100
						.d-flex.align-items-center.mb-2.mb-xl-0
							p {{ $t('general_advice') }} /
							img(src='@/assets/images/footer_logo1.png')
						.d-flex.align-items-center.flex-wrap
							p {{ $t('general_organizer') }} /
							img(src='@/assets/images/footer_logo2.png')
							img(src='@/assets/images/footer_logo3.png')
	#particle_footer
</template>

<script>
import { tsParticles } from 'tsparticles';
import ParticleConfig from '@/assets/particles.json';
export default {
	data() {
		return {
			particle_top: null,
		};
	},
	mounted() {
		setTimeout(() => {
			tsParticles.load('particle_footer', ParticleConfig);
			this.particle_top = tsParticles.domItem(1);
		}, 1000);
	},
};
</script>

<style lang="stylus">
.footer_outline
	position: relative
.particle_wrapper.footer
	height: 150px
	background: linear-gradient(180deg, rgba(11, 46, 91, 0) 50%, #0B2E5B 100%)
#particle_footer
	position: absolute
	width: 100%
	height: 250px
	top: 40%
	left: 50%
	transform: translate(-50%, -50%)
#footer
	position: relative
	padding: 2rem
	text-align: left
	color: #fff
	background-color: $color_dark
	.info
		height: 100%
	img
		height: 20px
		margin: 0 20px 0 10px
		&.logo
			height: 30px
			margin: 0 0 60px
	.desc
		font-size: 14px
	.sponsor
		height: 100%
		display: flex
		align-items: flex-end
		p
			margin: 0
	@media screen and (max-width: $screen-sm-max)
		padding: 1rem 10px
		.sponsor
			padding: 1rem 0
</style>
